import { ReactNode } from "react";
import { ScrollArea } from "../../common/scroll-area";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../../common/sheet";
import { TwScope } from "../../TwScope";

interface CommonModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  subtitle?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  showCloseButton?: boolean;
  closeOnOutsideClick?: boolean;
  closeOnEscape?: boolean;
  className?: string;
  contentClassName?: string;
  headerClassName?: string;
}

const CommonSideModal = ({
  isOpen,
  onClose,
  children,
  title,
  subtitle,
  showCloseButton = true,
  contentClassName
}: CommonModalProps) => {
  return (
    <Sheet open={isOpen} onOpenChange={open => !open && onClose()}>
      <SheetContent
        side="right"
        className={`tw-w-full tw-max-w-6xl !tw-p-0 tw-flex tw-flex-col tw-gap-0 ${contentClassName ?? ""}`}
      >
        <SheetHeader className="tw-px-5  tw-p-4 tw-border-b tw-border-border tw-shrink-0 tw-items-start">
          <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
            <div className="tw-flex-1 tw-px-1">
              <SheetTitle className="tw-font-display tw-text-xl">{title}</SheetTitle>
              {subtitle && (
                <p className="tw-text-sm tw-text-muted-foreground tw-mt-0.5 tw-font-normal">{subtitle}</p>
              )}
            </div>
          </div>
        </SheetHeader>
        <ScrollArea className="tw-flex-1 tw-bg-white tw-px-4 tw-pt-4">
          <TwScope className={contentClassName}>{children}</TwScope>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};

export default CommonSideModal;
